import type { TDimensionLegendEnCn, TDimensionLegendGetter } from './_type';

/**
 * dimRawCode 形如 `1_us` 时按两段分别走 selector 映射，再拼接为「Android_美国」类图例
 */
export const mapCompositeDimensionLegend = (
  dimRawCode: string,
  primaryMapKey: string,
  compositeKeys: [string, string] | undefined,
  getLegend: TDimensionLegendGetter,
): TDimensionLegendEnCn => {
  if (
    !compositeKeys ||
    compositeKeys.length !== 2 ||
    typeof dimRawCode !== 'string' ||
    !dimRawCode.includes('_')
  ) {
    return getLegend(primaryMapKey, dimRawCode);
  }
  const idx = dimRawCode.indexOf('_');
  const left = dimRawCode.slice(0, idx);
  const right = dimRawCode.slice(idx + 1);
  if (!left || !right) {
    return getLegend(primaryMapKey, dimRawCode);
  }
  const l = getLegend(compositeKeys[0], left);
  const r = getLegend(compositeKeys[1], right);
  return {
    enName: `${l.enName}_${r.enName}`,
    cnName: `${l.cnName}_${r.cnName}`,
  };
};
